module.exports = __webpack_public_path__ + "img/index-info.8ff8aef.jpg";